<template>
  <div
    id="cf"
    class="personal-center_wealth"
    :class="$route.query.themeStyleVs == 2 ? 'black_theme' : 'white_theme'"
  >
    <ul class="nav_tabs">
      <li
        v-for="(item, index) in tabs"
        :key="index"
        :class="checkedID === index + 1 ? 'checkedClass' : ''"
        @click="handleClickTabs(index + 1)"
      >
        {{ item }}
      </li>
    </ul>

    <p class="census">近7天 共{{ totalCount }}个</p>

    <ul class="wealth_card" v-if="wealth_card.length">
      <li
        v-for="(item, index) in wealth_card"
        :key="index"
        :class="item.status === 1 ? 'shengxiaoBg' : 'shixiaoBg'"
        @click="goDetails(item.status, item.code)"
      >
        <div class="top">
          <div class="top_left">
            <p class="pw">#</p>
            <template v-for="(item2, index2) in convertToCommaSeparatedArray(item.code)">
              <p class="pw" :key="index2" v-if="item2 !== ','">
                {{ item2 }}
              </p>
            </template>
          </div>
          <img
            src="@/assets/image/copy.png"
            alt=""
            class="copy"
            @click.stop="copyTextToClipboard(item.code)"
            v-if="item.status === 1"
          />
        </div>

        <p class="residue" v-if="item.status === 1">
          剩余次数<span style="font-size: 16px; margin-left: 4px"
            ><span class="num">{{ item.maxtimes - item.times }}</span
            >/{{ item.maxtimes }}</span
          >
        </p>

        <div class="time" v-if="item.status === 1">
          <van-row gutter="4">
            <van-col span="12">
              <div class="time_block">
                <p>{{ item.ctime }}</p>
                <p>生效时间</p>
              </div>
            </van-col>
            <van-col span="12">
              <div class="time_block">
                <p>{{ item.etime }}</p>
                <p>截止时间</p>
              </div>
            </van-col>
          </van-row>
        </div>

        <div class="btn" v-if="item.status === 1">
          <van-button
            type="primary"
            :loading="loading_abandon"
            loading-text="作废..."
            @click.stop="removeKlFun(item.codeId)"
            >作废</van-button
          >
        </div>

        <!-- 失效状态 -->
        <p class="shixiaoTime" v-if="item.status === 2">
          失效时间 <span> {{ item.etime }}</span>
        </p>
      </li>
    </ul>

    <van-empty description="暂无数据" :image="require('@/assets/image/notData.png')" v-else />
  </div>
</template>

<script>
import mixin from '@/mixins/index.js';
import {
  judgeColor,
  toFixedNum,
  removeValueFromArray,
  fangDouFun,
  dateFormat,
  compareVersions
} from '@/utils/format';
import { getMyKoulin, removeKl } from '@/api/my.js';

export default {
  name: 'Personal_Wealth',
  mixins: [mixin],
  data() {
    return {
      checkedID: 1,
      tabs: ['生效中', '已失效'],
      wealth_card: [],
      totalCount: 0,
      loading_abandon: false
    };
  },
  //计算属性
  computed: {
    checkedYzList: function () {
      return this.$store.state.checkedYzList; // 获取全局状态
    },
    Obj: function () {
      return this.$store.state.Obj; // 获取全局状态
    },
    contentNavBar: function () {
      return this.$store.state.contentNavBar; // 获取全局状态
    },
    publicHcID: function () {
      return this.$store.state.publicHcID; // 获取vuex的id 要是存在id走编辑逻辑
    }
  },

  watch: {},
  components: {},
  filters: {},
  created() {},
  mounted() {
    // this.checkedID = Number(this.getUrlQuery('smallTab'))
    //   ? Number(this.getUrlQuery('smallTab'))
    //   : 1;
    this.checkedID = this.$store.state.smallTab ? this.$store.state.smallTab : 1;
    this.getMyKoulinFun();
  },
  methods: {
    dateFormat,
    compareVersions,
    handleClickTabs: function (index) {
      this.checkedID = index;
      // this.$router.push(
      //   `${this.$route.path}?token=${this.getUrlQuery('token')}&tab=cf&smallTab=${index}`
      // );
      this.$store.commit('setSmallTab', index);
      this.getMyKoulinFun();
    },
    convertToCommaSeparatedArray: function (str) {
      const arr = str.split('');
      return arr.join(',');
    },

    //获取列表数据
    getMyKoulinFun: function () {
      this.$toast.loading({
        message: '加载中...',
        overlay: true,
        duration: 0
      });
      getMyKoulin({
        pageNumber: 1,
        pageSize: 200,
        status: this.checkedID //状态 0-全部 1-生效中 2-已失效
      })
        .then((res) => {
          this.$toast.clear();
          if (res.err === 200) {
            this.wealth_card = res.data.data.list;
            this.totalCount = res.data.data.totalCount;
          }
        })
        .catch((err) => {
          this.$toast(err);
        });
    },

    //复制文本到剪切板
    copyTextToClipboard: function (text) {
      try {
        let span = document.createElement('span');
        let Text = document.createTextNode('#' + text);
        span.appendChild(Text);
        document.body.appendChild(span);
        window.getSelection().selectAllChildren(span);
        document.execCommand('Copy');
        document.body.removeChild(span);
        this.$toast('财富口令已复制到剪切板,快去告诉TA吧');
      } catch (error) {
        this.$toast('无法复制文本到剪贴板');
      }
    },

    //作废财富口令
    removeKlFun: function (id) {
      this.$dialog
        .confirm({
          getContainer: '#cf',
          confirmButtonText: '我再想想',
          cancelButtonText: '确定',
          message: '执行作废操作后该财富口令将失效，失效后无法再次激活，是否确定？'
        })
        .then(() => {})
        .catch(() => {
          this.loading_abandon = true;
          removeKl({
            codeId: id
          })
            .then((res) => {
              this.loading_abandon = false;
              if (res.err === 200) {
                this.getMyKoulinFun();
              }
              this.$toast(res.msg);
            })
            .catch((err) => {
              this.loading_abandon = false;
              this.$toast(err);
            });
        });
    },
    goDetails: function (status, id) {
      if ( !compareVersions(this.getUrlQuery('version'), 9.66) && window.config.editionText !== '') {
        this.$emit('diagShow', true);
        return;
      }
      if (status === 1) {
        this.$store.commit('setSmallTab', id);
        window.location.href = `dzh_browser_url&goto=0&screen=464&treasureid=${id}`;
      }
    }
  }
};
</script>
<style lang="less" scoped>
.personal-center_wealth {
  .nav_tabs {
    padding: 12px 12px 0;
    display: flex;
    align-items: center;
    li {
      padding: 4px 16px;
      border-radius: 2px;
      background: #fff;
      margin-right: 8px;
      font-size: 12px;
      font-weight: 400;
    }
    .checkedClass {
      background: #286df7;
      color: #fff;
    }
  }
  .census {
    padding: 0 12px;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    margin: 8px 0;
  }
  .wealth_card {
    height: calc(100vh - 190px);
    overflow-y: auto;
    padding: 0 12px 12px;
    -webkit-overflow-scrolling: touch;
    .shengxiaoBg {
      background: #fff url('../../assets/image/shengxiao.png') top right no-repeat;
      background-size: 70px 70px;
      background-position: 104% -15px;
    }
    .shixiaoBg {
      background: #fff url('../../assets/image/shixiao.png') top right no-repeat;
      background-size: 70px 70px;
      background-position: 104% -15px;
    }
    li {
      padding: 12px;
      border-radius: 8px;
      box-shadow: 0px 4px 20px 0px rgba(0, 13, 134, 0.1);
      margin-bottom: 8px;
      .top {
        display: flex;
        align-items: center;
        .top_left {
          display: flex;
          align-items: center;
          .pw {
            width: 24px;
            height: 24px;
            border-radius: 4px;
            background: #f7f8fa;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-right: 4px;
          }
        }
        .copy {
          width: 24px;
          height: 24px;
        }
      }
      .residue {
        padding: 14px 0;
        color: #555;
        font-size: 12px;
        font-weight: 400;
        display: flex;
        align-items: center;
        .num {
          color: #286df7;
        }
      }
      .time {
        .time_block {
          padding: 12px 16px;
          border-radius: 4px;
          background: #f7f8fa;
          text-align: center;
          p {
            &:first-child {
              color: #555;
              font-size: 14px;
              font-weight: 500;
              line-height: 16px;
            }
            &:last-child {
              color: #999;
              font-size: 12px;
              font-weight: 400;
              line-height: 16px;
              margin-top: 4px;
            }
          }
        }
      }
      .btn {
        margin-top: 4px;
        .van-button {
          width: 100%;
          height: 22px;
          border-radius: 4px;
          background: rgba(40, 109, 247, 0.1);
          border: none;
          color: #286df7;
          font-size: 12px;
        }
      }
      .shixiaoTime {
        font-size: 12px;
        font-weight: 400;
        color: #555;
        margin-top: 8px;
        span {
          color: #222;
          font-size: 14px;
          font-weight: 500;
          margin-left: 4px;
        }
      }
    }
  }
}
</style>

<!-- 黑色主题 -->
<style lang="less" scoped>
.black_theme {
  .nav_tabs {
    li {
      background: #1d202d;
      color: #e4e9fe;
    }
  }
  .census {
    color: #aab9d1 !important;
  }
  .wealth_card {
    .shengxiaoBg {
      .time_block {
        background: #1d202d !important;
        p {
          &:first-child {
            color: #aab9d1 !important;
          }
          &:last-child {
            color: #6b7687 !important;
          }
        }
      }
    }
    .residue {
      color: #aab9d1 !important;
    }
    .shengxiaoBg {
      background: #181a23 url('../../assets/image/shengxiao.png') top right no-repeat !important;
      background-size: 70px 70px !important;
      background-position: 104% -15px !important;
    }
    .shixiaoBg {
      background: #181a23 url('../../assets/image/shixiao2.png') top right no-repeat !important;
      background-size: 70px 70px !important;
      background-position: 104% -15px !important;
    }
    .pw {
      background: #1b1d29 !important;
      color: #7f8190;
    }
    .shixiaoTime {
      color: #aab9d1 !important;
      span {
        color: #e4e9fe !important;
      }
    }
  }
  #cf {
    ::v-deep {
      .van-dialog {
        background: #181a23;
      }
      .van-dialog__message,
      .van-dialog__cancel .van-button__text {
        color: #aab9d1 !important;
      }
    }
  }
}
</style>
